import React, { useEffect, useState } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from './ui/carousel';
import { cn } from '../lib/utils';

export default function AutoCarousel({ children, interval = 5000, itemClassName = '', className = '', showArrows = true, testId }) {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    api.on('select', onSelect);
    return () => api.off('select', onSelect);
  }, [api]);

  useEffect(() => {
    if (!api || paused) return;
    const timer = setInterval(() => api.scrollNext(), interval);
    return () => clearInterval(timer);
  }, [api, paused, interval]);

  const items = React.Children.toArray(children);

  return (
    <div
      className={cn('relative', className)}
      data-testid={testId}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <Carousel setApi={setApi} opts={{ loop: true, align: 'start' }} className="w-full">
        <CarouselContent>
          {items.map((child, i) => (
            <CarouselItem key={i} className={itemClassName}>{child}</CarouselItem>
          ))}
        </CarouselContent>
        {showArrows && count > 1 && (
          <>
            <CarouselPrevious className="hidden md:flex -left-4 bg-white/90 shadow-md" />
            <CarouselNext className="hidden md:flex -right-4 bg-white/90 shadow-md" />
          </>
        )}
      </Carousel>
      {count > 1 && (
        <div className="flex justify-center gap-1.5 mt-4">
          {Array.from({ length: count }).map((_, i) => (
            <button
              key={i}
              onClick={() => api?.scrollTo(i)}
              className={cn('h-1.5 rounded-full transition-all', i === current ? 'w-6 bg-primary' : 'w-1.5 bg-slate-300 hover:bg-slate-400')}
              aria-label={`Go to slide ${i + 1}`}
              data-testid={testId ? `${testId}-dot-${i}` : undefined}
            />
          ))}
        </div>
      )}
    </div>
  );
}
